export const DEFAULT_SCOPES =
  'openid profile email transports:read transports:create transports:update tours:admin transports:update_planned_time_window transports:delete transports:cancel_in_transport transports:plan transports:finish transports:finish_external transportation_orders:read transportation_orders:plan exchange:create exchange:cancel subrent:create subrent:update subrent:cancel subrent:read subrent:confirm_end_date subrent:return job:schedule model_versions:read drivers:read config:write config:publish notifications:read notifications:update notifications:clear depots:read rental_responsibles:read instance:calculate_rental_state instances:read reservations_instance:read reservations_operator:read reservations_instance:write reservations_operator:write drivers:write fleet_overview:read model_groups:read operators:read operators:write truck_mounted_planning:read delivery_status_board:read qdrive_protocol:request qdrive_protocol:admin opco:CZ01 opco:HU01 opco:PL01 opco:PL03 opco:MX01 opco:MX03 opco:BE01 opco:BE02 opco:BE03 opco:LU01 opco:CL01 opco:PA01 opco:NL01 opco:NL02 opco:DE01 qdrive_opco:CZ01 qdrive_opco:HU01 qdrive_opco:PL01 qdrive_opco:MX01 qdrive_opco:MX03 qdrive_opco:BE01 qdrive_opco:BE02 qdrive_opco:LU01 qdrive_opco:CL01 qdrive_opco:PA01 qdrive_opco:NL01 qdrive_opco:DE01';

/**
 * TODO : use when all features are needed
 * `MockAuthService` hardcodes this constant as the scope of its fake access token, regardless of
 * which of `DEFAULT_SETTINGS`/`SETTINGS_INCLUDING_IT_ALL_FEATURES` is stubbed for `GetSettings`.
 * So every e2e test currently runs as without `it:all_features` user; to actually exercise the
 * "all features" experience, `MockAuthService` itself needs to stop hardcoding this constant and
 * derive its token scope from the stubbed settings (or a fixture) instead.
 *
 * frontend/storageState.json sets a cookie `auth.disabled=true` for every Playwright test, which
 * makes `provide-authentication.ts` use `MockAuthService` instead of the real Auth0 `AuthService`.
 */
const ALL_SCOPES_INCLUDING_IT_ALL_FEATURES = `${DEFAULT_SCOPES} it:all_features`;

export const DEFAULT_SETTINGS = {
  auth0: {
    domain: 'mateco-dev.eu.auth0.com',
    clientId: 'BDt0ZcwCpA3S1hde79pfLhhjNY6QWipe',
    audience: 'qplanning',
    scope: DEFAULT_SCOPES,
  },
  sentry: {
    enabled: false,
    dsn: 'https://df5a225dd6f3479bacd892c23aeea551@o233518.ingest.sentry.io/5521545',
  },
  document_archive_url: 'https://qa.qarchive.doctorb.qone.mateco.eu/file/search',
  dsb_url: 'https://qa.dsb.qone.mateco.eu',
  drive_service_url: 'http://localhost:8126',
  environment: 'local',
};

// TODO : use when all features are needed
const SETTINGS_INCLUDING_IT_ALL_FEATURES = {
  ...DEFAULT_SETTINGS,
  auth0: {
    ...DEFAULT_SETTINGS.auth0,
    scope: ALL_SCOPES_INCLUDING_IT_ALL_FEATURES
  }
};
